import { toSnakeCase } from '../packages/utils/casing'
import ApiBase from './Api'

const USER_EVENT_API_PATHS = {
    EVENTLOG: '/eventlog',
}

const EVENT_TYPES = {
    FILTER_CALENDAR: 'FILTER_CALENDAR',
    FILTER_COMPANIES: 'FILTER_COMPANIES',
    FILTER_ISSUES: 'FILTER_ISSUES',
    FILTER_WARRANTS: 'FILTER_WARRANTS',
    SEARCH: 'SEARCH',
    SHOW_ALL_ISSUES: 'SHOW_ALL_ISSUES',
    SHOW_ISSUE: 'SHOW_ISSUE',
    SHOW_ALL_WARRANTS: 'SHOW_ALL_WARRANTS',
    SHOW_WARRANT: 'SHOW_WARRANT',
    SHOW_ALL_CONVERTIBLES: 'SHOW_ALL_CONVERTIBLES',
    SHOW_CONVERTIBLE: 'SHOW_CONVERTIBLE',
    SHOW_ALL_COMPANIES: 'SHOW_ALL_COMPANIES',
    SHOW_COMPANY: 'SHOW_COMPANY',
    SHOW_ALL_INVESTORS: 'SHOW_ALL_INVESTORS',
    SHOW_INVESTOR: 'SHOW_INVESTOR',
    SHOW_ALL_NEWS: 'SHOW_ALL_NEWS',
    SHOW_ALL_USERS: 'SHOW_ALL_USERS',
    SHOW_STATS_TREND_GRAPHS: 'SHOW_STATS_TREND_GRAPHS',
    SHOW_STATS_SCATTER_PLOT: 'SHOW_STATS_SCATTER_PLOT',
    SHOW_STATS_ISSUE_MARKET: 'SHOW_STATS_ISSUE_MARKET',
    STATS_TREND_GRAPHS_SELECTION: 'STATS_TREND_GRAPHS_SELECTION',
    STATS_SCATTER_PLOT_SELECTION: 'STATS_SCATTER_PLOT_SELECTION',
    STATS_ISSUE_MARKET_SELECTION: 'STATS_ISSUE_MARKET_SELECTION',
    LOGIN: 'LOGIN',
    SHOW_WATCH_LIST: 'SHOW_WATCH_LIST',
    ADD_WATCH_LIST_ITEM: 'ADD_WATCH_LIST_ITEM',
    DELETE_WATCH_LIST_ITEM: 'DELETE_WATCH_LIST_ITEM',
}

export type UserEventType = keyof typeof EVENT_TYPES

class UserEventApi extends ApiBase {
    /**
     * Note: these should be the same (or a subset of) the event types defined
     * in the server-side UserEventApiHandler class.
     */
    static EVENT_TYPES = EVENT_TYPES as Record<UserEventType, UserEventType>

    async logEvent(event_type: UserEventType, event_details: Record<string, unknown> = {}) {
        if (!event_type || !(event_type in UserEventApi.EVENT_TYPES)) {
            throw new Error(`Invalid event type: ${event_type}`)
        }
        const response = await this._postRequest(
            USER_EVENT_API_PATHS.EVENTLOG,
            toSnakeCase({
                event_type,
                ...event_details,
            }),
        )
        return response
    }
}

export default UserEventApi
